import ls from '../../utils/localStorage.js';
import { getLogin,getRegister } from '../../api/api';

const state = {
    accessToken: ls.getItem('access_token') ? ls.getItem('access_token') : null
}

const mutations = {
    UPDATE_ACCESS_TOKEN(state,payload) {
        state.accessToken = JSON.parse(payload);
    }
}

const getters = {

}

const actions = {
    // 接收登录数据
    requestLogin(store,item) {
        getLogin(item.data).then( data => {
            ls.setItem('access_token',data);
            store.commit('UPDATE_ACCESS_TOKEN',JSON.stringify(data));
            item.loginToast.clear();
            return window.location.href="/user";
        }).catch(error => {
            item.loginToast.clear();
            item.thit.$toast('账号和密码错误');
        });
    },

    // 注册用户
    requestRegister(store,item) {
        getRegister(item.data).then( data => {
            ls.setItem('access_token',data);
            store.commit('UPDATE_ACCESS_TOKEN',JSON.stringify(data));
            item.registerToast.clear();
            return window.location.href="/user";
        }).catch(error => {
            if(error.response.data.errors.phone) {
                item.thit.$toast.fail({
                    duration: 800,
                    message: error.response.data.errors.phone[0]
                });
                return false;
            }

            if(error.response.data.errors.password) {
                item.thit.$toast.fail({
                    duration: 800,
                    message: error.response.data.errors.password[0]
                });
                return false;
            }else{
                item.thit.$toast.fail({
                    duration: 800,
                    message: "系统异常"
                });
                return false;
            }
        });
    }

}

export default {
    state,
    mutations,
    getters,
    actions
}
